import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {CompetitionWz} from "../interface/competition-wz";
import {CompetitionImportRow} from "../interface/competition-import-row";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class CompetitionWzService {
  public readonly wzListSubject: ReplaySubject<CountedAndPaginated<CompetitionWz>>
    = new ReplaySubject<CountedAndPaginated<CompetitionWz>>(1);

  public readonly importRowsListSubject: ReplaySubject<CountedAndPaginated<CompetitionImportRow>>
    = new ReplaySubject<CountedAndPaginated<CompetitionImportRow>>(1);


  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public addToWZ(competitionRowIds: string[]): Observable<any> {
    return this.httpClient.post(`/rest/crm/competitions/addToWz`, {
      competitionRows: competitionRowIds
    }).pipe(first());
  }

  public confirmWZ(competitionWzRowsIds: string[]): Observable<any> {
    return this.httpClient.post(`/rest/crm/competitions/confirmWz`, {
      competitionWzRows: competitionWzRowsIds
    }).pipe(first());
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/competition-wz?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<CompetitionWz>) => {
        this.wzListSubject.next(result);
      });
  }

  public getCompetitionWzRows(competitionWzId: string, page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/competition-wz/${competitionWzId}/import-rows?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<CompetitionImportRow>) => {
        this.importRowsListSubject.next(result);
      });
  }

  public deleteCompetitionWzRow(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/competition-wz/${uuid}`)
      .pipe(first());
  }

  downloadPdf(competitionWzId: string): void {
    this.document.location.href = `/rest/crm/competition-wz/${competitionWzId}/document`;
  }
  downloadProtocols(competitionWzId: string): void {
    this.document.location.href = `/rest/crm/competition-wz-protocols/${competitionWzId}/document`;
  }

  downloadProtocol(competitionRowId: string): void {
    this.document.location.href = `/rest/crm/competition-row-protocol/${competitionRowId}/document`;
  }

  downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/competition-wz/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadRowsReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/competition-wz-rows/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

}
